// extracted by mini-css-extract-plugin
module.exports = {"card":"CardSliderCard_card__e3_Q8","cardDefault":"CardSliderCard_cardDefault__NoBJI","cardBackdrop":"CardSliderCard_cardBackdrop__0_1c9","link":"CardSliderCard_link__oOEow"};